'use client'

import CalendarCard from "@/src/component/Global/CalendarCard"

/**
 * Retourne un composant affichant les prochains évenemnt
 * @param {object} parametter - Paramètre du composant.
 * @param {"fr"|"en"|"nl"} parametter.lang - Langue du site web.
 * @param {object} parametter.locale - Dictionnaire de la page d'acceuil du site web (local.homepage)
 * @param {object} parametter.locale2 - Dictionnaire du calendrier du site web (local.calendar)
 * @param {object} parametter.locale3 - Dictionnaire du site web
 * @param {Array<object>} parametter.events - Liste des événements
 * @returns 
 */
export default function FuturEvent({locale,locale2,links,events,lang,locale3}){
    const futurEvents = []
    const eventFiltered = events.filter((el)=>(el.show !=="on"))
    let count = 0
    for(let i=0;i<eventFiltered.length;i++){
        if(eventFiltered[i] && count!=6 && new Date(eventFiltered[i].date_debut)>new Date()) {
            futurEvents.push(eventFiltered[i]);
            count++
        }
        
    }

    const mounth = [
        locale2.month.january,
        locale2.month.february,
        locale2.month.march,
        locale2.month.april,
        locale2.month.may,
        locale2.month.june,
        locale2.month.july,
        locale2.month.august,
        locale2.month.september,
        locale2.month.october,
        locale2.month.november,
        locale2.month.december

    ]

    function isTwoDayBefore(eventDate){
        let dateX = new Date(eventDate);

        let today = new Date();
        today.setHours(0, 0, 0, 0); 
        let datePlus2Days = new Date(today);
        datePlus2Days.setDate(today.getDate() + 3);

        if (dateX.getTime() <= datePlus2Days.getTime()) {
            return true;
        } else {
            return false;
        }
    }

    
    return(
        <div className="lg:p-20 p-8 Futur-Event text-center  relative">
            <h2 className=" text heading-3 font-bold mb-2">{locale.IncomingEvents}</h2>
            <div className="overflow-x-auto mb-2">
                <div className="relative grid grid-cols-6 my-8 justify-between items-center gap-6 w-[1000px] h-[250px] lg:w-full">
                    {
                        futurEvents.map((e,i)=> <CalendarCard key={i} disabled={e?.showAgenda=="on"} title={e.titre[lang]} day={new Date(e.date_debut).getDate()} mount={mounth[new Date(e.date_debut).getMonth()]} isFull={e.isFull=="on"||isTwoDayBefore(e.date_debut)} fullText={locale.Full} id={e.id} lang={lang} local={locale3}/> )
                    }
                    
                </div>
            </div>
            <button className="button-primary-2 large-button w-full lg:w-auto" onClick={()=>location=links.Agenda}>
                {locale.button}
            </button>
        </div>
    )
    
}